import type { AppRouteRecordRaw } from '/@/router/types';
import { t } from '@mcex/locale';
import { LAYOUT2 } from '/@/router/constant';

const helpRoutes: AppRouteRecordRaw = {
  path: '/help',
  name: 'Help',
  component: LAYOUT2,
  redirect: '/help/index',
  meta: {
    title: t('help.helpCenter'),
    hideMenu: true,
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'index',
      name: 'HelpIndex',
      component: () => import('/@/views/help/index.vue'),
      meta: {
        title: t('help.helpCenter'),
      },
    },
    {
      path: ':articleId',
      name: 'HelpDetail',
      component: () => import('/@/views/help/article.vue'),
      meta: {
        title: t('help.helpCenter'),
        hideBreadcrumb: true,
      },
    },
  ],
};

export default helpRoutes;
